import React, { useEffect, useState, useCallback } from "react";
import API from "../Services/Designation";
import { toast } from "react-toastify";
const DesignationList = ({ selectedDesignation, setSelectedDesignation, designation }) => {

    const [designations, setDesignations] = useState([]);
    const [error, setError] = useState(null);

    const handleChange = (e) => {
        setSelectedDesignation(e.target.value);
    };


    const bindDesignation = useCallback(async () => {
        try {
            const response = await API.bindDesignation({
                is_active: 1
            });
            setDesignations(response?.data?.data.rows);
            //console.log(response?.data?.data);
        } catch (error) {
            setError("Failed to fetch designations.");
            console.error(error);
            if (error.response.status === 403) {
                window.location.replace("/Login");
            } else if (error.response.status === 404) {
                toast.error("Requested resource not found.");
               // window.location.replace("/Login");
            } else {
                setError("Failed to fetch designations.");
            }
        }
    }, []);

    useEffect(() => {
        bindDesignation();
    }, []);

    return (
        <div className="row">
            <div className="col-md-12">
                <div className="form-group">
                    <label htmlFor="Designation">Designation <span style={{ color: "red" }}>*</span></label>
                    <select className="form-select" id="ddlDesignation" value={selectedDesignation}
                        onChange={handleChange} required>
                        <option value="">Select</option>
                        {designations.length > 0 ? (
                            designations.map((designation) => (
                                <option key={designation.id} value={designation.id} >
                                    {designation.name}
                                </option>
                            ))
                        ) : (
                            <option disabled>No designations available</option>
                        )}
                    </select>
                    {error && <p style={{ color: 'red' }}>{error}</p>}
                </div>
            </div>
        </div>
    );
};

export default DesignationList;
